import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Services = ({ service }) => {
  useEffect(() => {
    const $ = window.$;

    if ($(".video-popup").length) {
      $(".video-popup").magnificPopup({
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: true,
        fixedContentPos: false,
      });
    }
  }, []);

  const publicUrl = process.env.PUBLIC_URL + "/";

  return (
    <section className="about-two">
      <div className="about-two-shape-1 float-bob-x">
        <img
          //   src={publicUrl + "assets/images/shapes/about-two-shape-1.png"}
          alt=""
        />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <div className="about-two__left">
              <div
                className="about-two__bg"
                style={
                  {
                    //   backgroundImage: `url(${publicUrl}assets/images/backgrounds/about-two-bg.jpg)`,
                  }
                }
              ></div>
              <div
                className="about-two__img-box wow slideInLeft"
                data-wow-delay="100ms"
                data-wow-duration="2500ms"
              >
                <div className="about-two__img">
                  <img
                    src={
                      publicUrl + "assets/images/resources/" + service.imageBig
                    }
                    onError={(e) => {
                      e.currentTarget.src =
                        publicUrl + "assets/images/resources/about-one-img-1.jpg";
                    }}
                    alt={service.title}
                  />
                </div>
                <div
                  className="about-two__small-img wow zoomIn animated animated"
                  data-wow-delay="500ms"
                  data-wow-duration="2500ms"
                >
                  <img
                    src={
                      publicUrl +
                      "assets/images/resources/" + service.imageSmall
                    }
                    onError={(e) => {
                      e.currentTarget.src =
                        publicUrl +
                        "assets/images/resources/about-one-small-img.jpg";
                    }}
                    alt=""
                    style={{ width: "170px" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="about-two__right">
              <div className="section-title text-left">
                <h2 className="section-title__title">{service.title}</h2>
              </div>

              {service.description.map((desc, i) =>
                desc === "list" ? (
                  <>
                    {service.list && service.lists && (
                      <ul className="list-unstyled about-two__points" key={i}>
                        {service.lists.map((li, k) => (
                          <li key={`${k}_${i}`}>
                            <div className="icon" key={li}>
                              <span className="icon-comment"></span>
                            </div>
                            <div className="text">
                              <span>{li}</span>
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <p
                    className="about-two__text wow fadeInUp"
                    data-wow-delay={`${i * 0.1}s`}
                    key={i}
                  >
                    {desc}
                  </p>
                )
              )}

              {service.links.map((link) => (
                <Link
                  key={link.text}
                  to={process.env.PUBLIC_URL + `/contact`}
                  className="thm-btn about-two__btn"
                  style={{ marginTop: "40px" }}
                >
                  {link.text}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
